import { Footer, Header } from 'components'
import { useUser } from 'context/user/user.context'
import * as Global from 'global/styles.global'
import { translate } from 'locales'
import React, { useEffect, useState } from 'react'
import BankData from './BankData'
import DoctorInfo from './DoctorInfo'
import FinancialTabs, { FinancialTabKey } from './FinancialTabs'
import Information from './Information'
import Invoices from './Invoices'
import MonthlyHistory from './MonthlyHistory'
import MonthlyHistoryDetail from './MonthlyHistoryDetail'
import Overview from './Overview'
import { findDoctorPlan } from './services'
import * as S from './styles'
import { IFinancialMonthRow } from './types'
import {
  isGeneralPractitionerDoctor,
  isNutritionistDoctor,
  isPsychologyDoctor,
  isStartPlan,
} from './utils'

const Financial = () => {
  const { userData } = useUser()
  const isPsychology = isPsychologyDoctor(userData)
  const isNutritionist = isNutritionistDoctor(userData)
  const isGeneralPractitioner = isGeneralPractitionerDoctor(userData)
  const lang = window.localStorage.getItem('@StarBem:lang') || 'pt'
  const locale = lang === 'en' ? 'en' : 'pt-br'
  const [activeTab, setActiveTab] = useState<FinancialTabKey>('overview')
  const [monthDetail, setMonthDetail] = useState<IFinancialMonthRow | null>(
    null
  )
  const [plan, setPlan] = useState<string | null>(null)
  const showTotalPassRates =
    Boolean(plan) && !isStartPlan(plan) && (isPsychology || isNutritionist)

  useEffect(() => {
    findDoctorPlan(setPlan)
  }, [userData.id])

  return (
    <Global.Container>
      <Header />

      <S.Content>
        {monthDetail ? (
          <S.DetailCard>
            <DoctorInfo userData={userData} plan={plan} compact />

            <MonthlyHistoryDetail
              detail={monthDetail}
              locale={locale}
              isPsychology={isPsychology}
              isNutritionist={isNutritionist}
              isGeneralPractitioner={isGeneralPractitioner}
              showTotalPassRates={showTotalPassRates}
              onBack={() => setMonthDetail(null)}
            />
          </S.DetailCard>
        ) : (
          <S.Card>
            <S.PageHeader>
              <div>
                <h1>{translate('financial.title')}</h1>

                <span className="page-subtitle">
                  {translate('financial.subtitle')}
                </span>
              </div>
            </S.PageHeader>

            <DoctorInfo userData={userData} plan={plan} />

            <FinancialTabs activeTab={activeTab} onChange={setActiveTab} />

            <S.TabContent>
              {activeTab === 'overview' && (
                <Overview locale={locale} isPsychology={isPsychology} />
              )}

              {activeTab === 'monthlyHistory' && (
                <MonthlyHistory
                  locale={locale}
                  onViewDetails={setMonthDetail}
                />
              )}

              {activeTab === 'invoices' && <Invoices locale={locale} />}

              {activeTab === 'information' && <Information />}

              {activeTab === 'bankData' && <BankData userData={userData} />}
            </S.TabContent>
          </S.Card>
        )}
      </S.Content>

      <Footer />
    </Global.Container>
  )
}

export default Financial
